import { Table } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import TaxRulesTableBody from './TaxRulesTableBody';
import { TaxRuleType } from '../types';

interface TaxRulesTableProps {
  readonly taxRules: TaxRuleType[];
}
function TaxRulesTable({ taxRules }: TaxRulesTableProps) {
  const t = useTranslationCatalog('products.detail.invoiceSettings');

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Cell backgroundColor="neutral-surface" as="th">
            {t('nameTaxRule')}
          </Table.Cell>
          <Table.Cell backgroundColor="neutral-surface" as="th">
            {t('namesStates')}
          </Table.Cell>
        </Table.Row>
      </Table.Head>
      <TaxRulesTableBody taxRules={taxRules} />
    </Table>
  );
}

export default TaxRulesTable;
